export default {
  isSidebarMinimized: false,
  userName: 'Vasili S',
  userInfo: {},
}